import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Hotel as HotelIcon, MapPin } from 'lucide-react';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
import { hotels } from '../data/hotels';
export function HotelsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-1098">
      {/* Hero */}
      <div className="border-b border-gray-200" data-id="element-1099">
        <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20 md:py-32" data-id="element-1100">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6
        }} className="max-w-4xl" data-id="element-1101">
            <div className="h-px w-16 bg-amber-500 mb-8" data-id="element-1102"></div>
            <h1 className="text-7xl md:text-9xl font-light text-gray-900 mb-6 leading-[0.9] tracking-tight" data-id="element-1103">
              Top
              <br data-id="element-1104" />
              <span className="font-serif italic" data-id="element-1105">Hotels</span>
            </h1>
            <p className="text-2xl md:text-3xl text-gray-600 leading-relaxed font-light max-w-2xl" data-id="element-1106">
              From historic colonial elegance to contemporary luxury, discover
              Nairobi's finest accommodations.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-8 lg:px-12 py-16" data-id="element-1107">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1108">
          {hotels.map((hotel, index) => <motion.div key={hotel.id} className="border border-gray-200 p-8 hover:border-amber-500 transition-all" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-1109">
              {/* Category Badge */}
              <span className="px-3 py-1 border border-gray-200 text-gray-600 text-xs font-light uppercase tracking-widest inline-block mb-4" data-id="element-1110">
                {hotel.category}
              </span>

              {/* Hotel Name */}
              <h3 className="text-2xl font-light text-gray-900 mb-2" data-id="element-1111">
                {hotel.name}
              </h3>

              {/* Location */}
              <div className="flex items-center gap-2 text-gray-500 mb-4" data-id="element-1112">
                <MapPin className="w-3 h-3" strokeWidth={1.5} data-id="element-1113" />
                <span className="text-xs font-light" data-id="element-1114">{hotel.location}</span>
              </div>

              {/* Description */}
              <p className="text-gray-700 leading-relaxed mb-6 font-light text-sm" data-id="element-1115">
                {hotel.description}
              </p>

              {/* Amenities */}
              <div className="mb-6" data-id="element-1116">
                <h4 className="text-xs font-light text-gray-500 uppercase tracking-wider mb-3" data-id="element-1117">
                  Amenities
                </h4>
                <ul className="space-y-2" data-id="element-1118">
                  {hotel.amenities.slice(0, 4).map((amenity, i) => <li key={i} className="flex items-start gap-2 text-xs text-gray-600 font-light" data-id="element-1119">
                      <div className="w-1 h-1 bg-amber-500 rounded-full mt-1.5 flex-shrink-0" data-id="element-1120"></div>
                      <span data-id="element-1121">{amenity}</span>
                    </li>)}
                </ul>
              </div>

              {/* Highlights */}
              <div className="pt-4 border-t border-gray-200" data-id="element-1122">
                <h4 className="text-xs font-light text-gray-500 uppercase tracking-wider mb-3" data-id="element-1123">
                  Highlights
                </h4>
                <ul className="space-y-2" data-id="element-1124">
                  {hotel.highlights.slice(0, 3).map((highlight, i) => <li key={i} className="flex items-start gap-2 text-xs text-gray-600 font-light" data-id="element-1125">
                      <div className="w-1 h-1 bg-amber-500 rounded-full mt-1.5 flex-shrink-0" data-id="element-1126"></div>
                      <span data-id="element-1127">{highlight}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>

      <ScrollToTop data-id="element-1128" />
      <Footer data-id="element-1129" />
    </div>;
}